var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditPhoto(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70.147,
    height: 63.893,
    viewBox: "0 0 70.147 63.893",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "add_a_photo_FILL1_wght400_GRAD0_opsz48",
    d: "M6.45,67.543a4.557,4.557,0,0,1-3.325-1.425A4.557,4.557,0,0,1,1.7,62.792V22.177a4.6,4.6,0,0,1,1.425-3.286A4.5,4.5,0,0,1,6.45,17.426H18.089l5.78-6.888H46.037v9.5h9.422v9.5h9.58V62.792a4.5,4.5,0,0,1-1.465,3.325,4.6,4.6,0,0,1-3.286,1.425ZM33.369,55.983A13.251,13.251,0,0,0,46.829,42.524,13.188,13.188,0,0,0,33.369,29.065,13.125,13.125,0,0,0,19.91,42.524,13.188,13.188,0,0,0,33.369,55.983Zm0-4.75a8.4,8.4,0,0,1-6.255-2.494,8.507,8.507,0,0,1-2.454-6.215,8.4,8.4,0,0,1,8.709-8.709,8.507,8.507,0,0,1,6.215,2.454,8.4,8.4,0,0,1,2.494,6.255,8.522,8.522,0,0,1-8.709,8.709ZM60.209,22.1V15.288H53.4v-4.75h6.809V3.65h4.75v6.888h6.888v4.75H64.959V22.1Z",
    transform: "translate(-1.7 -3.65)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPhoto);
export default __webpack_public_path__ + "static/media/edit_photo.5628700a1fd9b42a3bf7db701326c981.svg";
export { ForwardRef as ReactComponent };